// extracted by mini-css-extract-plugin
export default {"certification":"Certification_certification__ugLfl","certTitle":"Certification_certTitle__uE6qc"};